import ErrorToast from '@/components/toasts/ErrorToast';
import WarningModal from '@/components/toasts/WarningModal';

export default function install(Vue) {
    // register global components
    Vue.component(ErrorToast.name, ErrorToast);
    Vue.component(WarningModal.name, WarningModal);
}
